import AppliedApplicationTemplateModel from '../../../shared/models/templating/api/AppliedApplicationTemplateModel';
import TemplateFormFieldValueModel from '../../../shared/models/templating/api/TemplateFormFieldValueModel';
import TemplateFormSectionModel from '../../../shared/models/templating/api/TemplateFormSectionModel';

export interface MultilingualTemplateUpdate {
    appliedTemplateId: string;
    fieldValues: TemplateFormFieldValueModel[];
    templateFormSections: TemplateFormSectionModel[];
}

const normalizeAssociatedVariable = (value?: string): string =>
    (value || '').replace(/[{}]/g, '').trim().toLowerCase();

const isMultilingualField = (associatedVariable?: string): boolean =>
    normalizeAssociatedVariable(associatedVariable) === 'multilingual';

export const getMultilingualTemplateUpdates = (templates: AppliedApplicationTemplateModel[]): MultilingualTemplateUpdate[] => {
    const updates: MultilingualTemplateUpdate[] = [];
    (templates || []).forEach(template => {
        const currentSections = template.templateForm?.templateFormSections || [];
        const dynamicSections = template.dynamicFormSections || [];
        const sections = [...currentSections];
        dynamicSections.forEach(section => {
            const alreadyLoaded = sections.some(existing =>
                (section.id && existing.id === section.id)
                || (section.name && existing.name === section.name)
            );
            if (!alreadyLoaded) sections.push(section);
        });

        let fieldValues = [
            ...(template.templateFormFieldValues || []),
            ...(template.dynamicFormFieldValuesCache || [])
        ];
        let found = false;
        const matchedSections: TemplateFormSectionModel[] = [];
        sections.forEach(section => {
            const dynamicFields = (section.dynamicFormFields || []).filter(field => isMultilingualField(field.associatedVariable));
            const standardFields = (section.templateFormFields || []).filter(field => isMultilingualField(field.associatedVariable));
            const fields = dynamicFields.length ? dynamicFields : standardFields;
            if (fields.length) matchedSections.push(section);
            fields.forEach(field => {
                if (!field.name && !field.id) return;
                const matchesField = (value: TemplateFormFieldValueModel) => field.name
                    ? value.dynamicFormFieldName === field.name
                    : value.templateFormFieldId === field.id;
                const existing = fieldValues.find(matchesField)
                    || fieldValues.find(value => isMultilingualField(value.associatedVariable) && !value.templateFormFieldId && !value.dynamicFormFieldName);
                const updated: TemplateFormFieldValueModel = {
                    ...existing,
                    ...(field.name ? { dynamicFormFieldName: field.name, dynamicFormFieldId: field.id } : { templateFormFieldId: field.id }),
                    appliedApplicationTemplateId: template.id,
                    associatedVariable: '{Multilingual}',
                    fieldType: field.fieldType,
                    value: 'true'
                };
                const index = fieldValues.indexOf(existing);
                if (index >= 0) fieldValues[index] = updated;
                else fieldValues.push(updated);
                found = true;
            });
        });
        if (found) {
            const templateFormSections = [...currentSections];
            matchedSections.forEach(section => {
                const alreadyLoaded = templateFormSections.some(existing =>
                    (section.id && existing.id === section.id)
                    || (section.name && existing.name === section.name)
                );
                if (!alreadyLoaded) templateFormSections.push(section);
            });
            updates.push({ appliedTemplateId: template.id, fieldValues, templateFormSections });
        }
    });
    return updates;
};
